import { useEffect, useMemo, useState } from 'react';

import BlackFridayBg from '../../../assets/black-friday-bg.svg';
import BlackFridayCoinsImage from '../../../assets/black-friday-coins.svg';
import LogoBlackFriday from '../../../assets/logo-black-friday-2024.svg';
import { MLABS_TRANSLATOR_ON_CHANGE_LANGUAGE } from '../../../constants';
import api from '../../../services/api';
import { getLanguage } from '../../../services/auth';
import { transcodeLanguage } from '../../../utils/language';
import bannerBlackFridayData from './banner-black-friday.json';
import useCore from '../../../hooks/useCore';

import {
  BackgroundContainer,
  BannerImage,
  BannerWrapper,
  ContainerTexts,
  ContainerTextsMobile,
  Separator,
} from './styles';

const BlackFriday = () => {
  const [language, setLanguage] = useState('pt-BR');
  const [blackFriday, setBlackFriday] = useState(null);
  const [featureIsActive, setFeatureIsActive] = useState(false);
  const { fetchFeature } = useCore();
  const currentLanguage = getLanguage();

  window.addEventListener(MLABS_TRANSLATOR_ON_CHANGE_LANGUAGE, (event) => {
    setLanguage(transcodeLanguage(event.detail.language));
  });

  const getBlackFridayData = async () => {
    try {
      const response = await api.get('/black_friday/active', {});

      if (response.data.data) {
        const responseBlackFriday = response.data.data.attributes;
        setBlackFriday({
          id: responseBlackFriday.id,
          dateStart: responseBlackFriday['date-start'],
          dateEnd: responseBlackFriday['date-end'],
          untilCountDown: responseBlackFriday['until-count-down'],
          active: responseBlackFriday.active,
        });
      } else {
        setBlackFriday(null);
      }
    } catch (_) {
      setBlackFriday(null);
    }
  };

  const getBlackFridayBannerFeature = async () => {
    try {
      const response = await fetchFeature('black_friday', true);
      if (response?.data) {
        const blackFridayFt =
          response?.data.some(
            (item) => item.attributes.key === 'black_friday' && item.attributes.active,
          ) || false;

        setFeatureIsActive(blackFridayFt);
      }
    } catch (_) {
      setFeatureIsActive(false);
    }
  };

  useEffect(() => {
    if (currentLanguage) {
      setLanguage(transcodeLanguage(currentLanguage));
    }
  }, [currentLanguage]);

  useEffect(() => {
    getBlackFridayData();
    getBlackFridayBannerFeature();
  }, []);

  const bannerData = useMemo(() => bannerBlackFridayData[language], [language]);

  return (
    !!blackFriday?.active &&
    featureIsActive && (
      <BannerWrapper className="show" id="banner">
        <BackgroundContainer left="-100px">
          <img src={BlackFridayBg} alt="Black Friday Bg" />
          <img src={BlackFridayBg} alt="Black Friday Bg" />
        </BackgroundContainer>
        <BannerImage
          alt="Black Friday mLabs"
          title="logo-black-friday-mLabs"
          id="menu-logo"
          url={bannerData.logo}
          src={LogoBlackFriday}
        />
        <Separator />
        <ContainerTexts>
          <p
            translate="no"
            dangerouslySetInnerHTML={{
              __html: `<img src="${BlackFridayCoinsImage}" alt="Black Friday Coins" /> ${bannerData.textOne}`,
            }}
          />
          <p translate="no" dangerouslySetInnerHTML={{ __html: bannerData.textTwo }} />
          <p translate="no" dangerouslySetInnerHTML={{ __html: bannerData.textThree }} />
        </ContainerTexts>
        <ContainerTextsMobile>
          <p translate="no" dangerouslySetInnerHTML={{ __html: bannerData.textMobileOne }} />
          <p translate="no" dangerouslySetInnerHTML={{ __html: bannerData.textMobileTwo }} />
        </ContainerTextsMobile>
        <BackgroundContainer right="-78px">
          <img src={BlackFridayBg} alt="Black Friday Bg" />
          <img src={BlackFridayBg} alt="Black Friday Bg" />
          <img src={BlackFridayBg} alt="Black Friday Bg" />
        </BackgroundContainer>
      </BannerWrapper>
    )
  );
};

export default BlackFriday;
